import React from 'react';
import { Route } from 'react-router';
import { useTabs } from '../../hooks/useTabs';

interface Props {
  onClick?: () => void;
}

export const Select = React.forwardRef<HTMLDivElement, Props>(({ onClick }, ref) => {
  const { tabs } = useTabs();
  // обертка с рефом и онкликом нужна чтобы мобильный попап работал
  return (
    <div ref={ref} onClick={onClick}>
      {tabs.map(({ SelectItem, pathname, instrument }, i) => (
        <Route path={`/${pathname}`} key={i}>
          <SelectItem instrument={instrument} />
        </Route>
      ))}
    </div>
  );
});
